import { render, staticRenderFns } from "./CmsSummary.vue?vue&type=template&id=42ab8908"
import script from "./CmsSummary.vue?vue&type=script&lang=js"
export * from "./CmsSummary.vue?vue&type=script&lang=js"
import style0 from "./CmsSummary.vue?vue&type=style&index=0&id=42ab8908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports